import { useState, useEffect } from 'react';
import { useCommunity } from '../CommunityContext';
import { sdk } from '../sdk';
import { CheckoutConfig } from '../../types/checkout';

interface UseCheckoutConfigReturn {
  config: CheckoutConfig | null;
  loading: boolean;
  error: string | null;
}

export function useCheckoutConfig(): UseCheckoutConfigReturn {
  const { community } = useCommunity();
  const [config, setConfig] = useState<CheckoutConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!community?.id) {
      setLoading(false);
      return;
    }

    const fetchConfig = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await sdk.checkout.getConfig();
        setConfig(response);
      } catch (err: any) {
        console.error('[useCheckoutConfig] Failed to fetch checkout config:', err);
        setError(err.message || 'Failed to load checkout configuration');
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [community?.id]);

  return { config, loading, error };
}
